// extracted by mini-css-extract-plugin
module.exports = {"container":"TopChart_container__2MCWc","Title":"TopChart_Title__csFfm"};